import HttpRequest from './HttpRequest'

class HospitalContactProvider extends HttpRequest {
  findAll () {
    return this.get('/hospital-contact')
  }

  findOne (id) {
    return this.get(`/hospital-contact/${id}`)
  }

  create (payload) {
    return this.post('/hospital-contact', payload)
  }

  update (id, payload) {
    return this.patch(`/hospital-contact/${id}`, payload)
  }

  softDelete (id) {
    return this.delete(`/hospital-contact/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/hospital-contact?page=${page}&limit=${limit}`, query)
  }
}

export default HospitalContactProvider
